import { Star } from "lucide-react";
import { TAVERN } from "../../data/tavern";

export default function SocialProof() {
  return (
    <section
      id="social-proof"
      data-testid="social-proof-section"
      className="border-y border-[color:var(--pk-border)] bg-[color:var(--pk-surface-2)]/50 py-14 md:py-16"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 px-5 text-center md:px-8">
        {/* Google "logo" circle */}
        <div className="flex items-center gap-3">
          <span
            aria-hidden="true"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-base font-black shadow-sm ring-1 ring-[color:var(--pk-border)]"
          >
            <span className="bg-gradient-to-br from-[#4285F4] via-[#EA4335] to-[#FBBC05] bg-clip-text text-transparent">
              G
            </span>
          </span>
          <span className="text-sm font-semibold uppercase tracking-[0.24em] text-[color:var(--pk-text-soft)]">
            ΑΞΙΟΛΟΓΗΣΕΙΣ GOOGLE
          </span>
        </div>

        <div data-testid="rating-block" className="flex items-baseline gap-3">
          <span className="font-display text-5xl font-black text-[color:var(--pk-text)] md:text-6xl">
            {TAVERN.rating}
          </span>
          <span className="text-xl font-semibold text-[color:var(--pk-text-soft)]">
            / 5
          </span>
        </div>

        <div
          className="flex items-center gap-1"
          role="img"
          aria-label={`${TAVERN.rating} από 5 αστέρια`}
          data-testid="stars-row"
        >
          {[0, 1, 2, 3].map((i) => (
            <Star
              key={i}
              className="h-7 w-7 fill-[#F4B400] text-[#F4B400] md:h-8 md:w-8"
              strokeWidth={1.5}
            />
          ))}
          {/* 0.5 star representation */}
          <span className="relative inline-block h-7 w-7 md:h-8 md:w-8">
            <Star
              className="absolute inset-0 h-full w-full text-[#F4B400]"
              strokeWidth={1.5}
            />
            <span
              className="absolute inset-0 overflow-hidden"
              style={{ width: "50%" }}
              aria-hidden="true"
            >
              <Star
                className="h-7 w-7 fill-[#F4B400] text-[#F4B400] md:h-8 md:w-8"
                strokeWidth={1.5}
              />
            </span>
          </span>
        </div>

        <p
          data-testid="social-proof-text"
          className="max-w-xl text-base text-[color:var(--pk-text-soft)] md:text-lg"
        >
          <span className="font-bold text-[color:var(--pk-text)]">
            4.5/5 αστέρια
          </span>{" "}
          από{" "}
          <span className="font-bold text-[color:var(--pk-text)]">
            {TAVERN.reviews} κριτικές
          </span>{" "}
          Google — σας ευχαριστούμε για την αγάπη σας.
        </p>

        <div className="meander mt-2 text-sm uppercase tracking-[0.28em]">
          ΕΥΧΑΡΙΣΤΟΥΜΕ
        </div>
      </div>
    </section>
  );
}
